import { getFormattedAPR } from '@utils/formatter'

import { ContentProps } from './Content.interface'

const transferFeeContent = ({
    creditCard,
}: {
    creditCard: ContentProps['creditCard']
}) => {
    if (creditCard.offerDetail.introBalanceTransferFee == null) {
        return null
    }

    return {
        title: 'Balance transfer fee',
        value: getFormattedAPR(creditCard.offerDetail.introBalanceTransferFee),
        detailType: undefined,
    }
}

export default transferFeeContent
